/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Eingeladenesorgeberechtigte1Inputs */



/**

* @param {_Field_Eingeladenesorgeberechtigte1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_eingeladenesorgeberechtigte1 = /** @type {((inputs?: _Field_Eingeladenesorgeberechtigte1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Eingeladenesorgeberechtigte1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Eingeladene Sorgeberechtigte E-Mails")
});
export { _field_eingeladenesorgeberechtigte1 as "_field_eingeladeneSorgeberechtigte" }